import { ForecastParamCode, Geopoint, TimeStep24H } from 'pleinchamp-api-client';
import { ComponentPropsWithRef, RefObject } from 'react';
import { Dayjs } from 'dayjs';

export const MOCK_STRING = 'xx';

export enum Direction {
  Left,
  Right,
}

export const WEATHER_TABLE_CELL_WIDTH = 60;
export const NUMBER_OF_DEFAULT_METRICS = 13;

export interface WeatherTableProps extends ComponentPropsWithRef<'table'> {
  forecasts?: EnhancedTimeStep[];
  forecasts15Days?: TimeStep24H[];
  coordinates: Geopoint;
  isChartEnabled?: boolean;
  displayHHLink?: boolean;
  thirtySixHours?: boolean;
  withDays?: boolean;
  top?: number;
}

export interface MetricsType {
  key: ForecastParamCode;
  data: (string | number)[];
}

export type ForecastParamCode15Days = keyof TimeStep24H;
export interface MetricsType24H {
  key: ForecastParamCode15Days | 'moonPhase';
  data: (string | number)[];
}

export type WeatherTableContentProps = Omit<WeatherTableProps, 'forecasts'> & {
  dates: Dayjs[];
  format15Days?: boolean;
  weatherCodes: Array<number | undefined>;
  metrics: MetricsType[] | MetricsType24H[];
  timeframe: 'PT0S' | 'PT3H';
  isSeeMoreEnabledDefault?: boolean;
  isLoading?: boolean;
};

export function filterParamsToDisplay(m: MetricsType | MetricsType24H) {
  if (Number.isNaN((m.data as number[])[0]) && typeof m.data[0] === 'number') return false;
  if (
    m.key === ForecastParamCode.WeatherCode ||
    m.key === ForecastParamCode.AirTemperatureInCelsius ||
    m.key === 'date' ||
    m.key === 'mostSignificantWeatherCode' ||
    m.key === 'minRelativeHumidityInPercent' ||
    m.key === 'maxRelativeHumidityInPercent'
  ) {
    return false;
  }

  return true;
}

export function getScroll(ref: RefObject<HTMLDivElement>, dir: Direction) {
  if (!ref.current) {
    return undefined;
  }
  const { scrollLeft, scrollWidth, clientWidth } = ref.current;
  switch (dir) {
    case Direction.Left: {
      return scrollLeft;
    }
    case Direction.Right: {
      return scrollWidth - (scrollLeft + clientWidth);
    }
    default: {
      const testSwitch: never = dir;
      return testSwitch;
    }
  }
}
